export default function(s1, s2) {
  return (s1 || '').replace(/\s/g, '') === (s2 || '').replace(/\s/g, '');
}



// WEBPACK FOOTER //
// ./src/scripts/lib/equal_ignore_whitespace.js